import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldOff } from "lucide-react";

// Phase-1 security: public self-registration is DISABLED for MIRO One.
// Employee accounts are created by an HR Admin via the internal user
// management screen, not via a public form.
export default function Register() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--miro-bg)] p-6">
      <div className="w-full max-w-md bg-white border border-[var(--miro-border)] rounded-2xl p-8 text-center" data-testid="register-disabled-panel">
        <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center bg-red-50 text-red-600">
          <ShieldOff size={26}/>
        </div>
        <h1 className="font-display font-black text-2xl tracking-tight text-[var(--miro-navy)] mt-4">
          Self-registration is disabled
        </h1>
        <p className="text-sm text-[var(--miro-text-secondary)] mt-3">
          MIRO One is an internal CRM. Employee accounts are created by an HR Admin
          or Super Admin from the internal user management screen.
        </p>
        <p className="text-xs text-[var(--miro-text-muted)] mt-3">
          If you're a MIRO employee, please contact your line manager or HR to
          request access.
        </p>
        <Link to="/login" data-testid="register-back-to-login">
          <Button className="w-full mt-6 h-11" style={{ background: "var(--miro-navy)" }}>
            Back to sign in
          </Button>
        </Link>
      </div>
    </div>
  );
}
